import { render, staticRenderFns } from "./MovePatient.vue?vue&type=template&id=58140454&"
import script from "./MovePatient.vue?vue&type=script&lang=js&"
export * from "./MovePatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports